const REQUEST_FAILED_PATTERN = /^Request failed with status code \d+$/i;
const CFDI_CODE_PATTERN = /^(CFDI\d+)/;

function normalizeMessage(value) {
    if (value == null || value === '') {
        return null;
    }
    if (typeof value === 'string') {
        return value.trim();
    }
    if (typeof value === 'object') {
        if (typeof value.message === 'string' && value.message.trim()) {
            return value.message.trim();
        }
        if (typeof value.messageDetail === 'string' && value.messageDetail.trim()) {
            return value.messageDetail.trim();
        }
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    return String(value);
}

function extractProviderCode(message, data) {
    if (data?.code && typeof data.code === 'string') {
        return data.code;
    }
    const match = message?.match(CFDI_CODE_PATTERN);
    return match ? match[1] : null;
}

export function formatApiErrorMessage(error, fallback = 'Something went wrong, try later') {
    const data = error?.response?.data;
    const status = data?.statusCode ?? error?.response?.status;
    let message = normalizeMessage(data?.message);

    if (!message) {
        const axiosMessage = error?.message;
        if (axiosMessage && !REQUEST_FAILED_PATTERN.test(axiosMessage)) {
            message = axiosMessage.trim();
        } else {
            message = fallback;
        }
    }

    const code = extractProviderCode(message, data);
    if (status && code) {
        return `[${status}] ${code} — ${message}`;
    }
    if (status) {
        return `[${status}] ${message}`;
    }
    if (code) {
        return `${code} — ${message}`;
    }
    return message;
}

export default formatApiErrorMessage;
